import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      name,
      value,
      title,
      options,
      optionValues,
      onChange,
      disabledOptions,
      customOnChange,
      disabled,
      className,
    } = this.props;
    return (
      <select
        disabled={disabled}
        name={name}
        value={value}
        onChange={customOnChange ? (e) => onChange(e.target.value) : onChange}
        className={"fe-u-select custom-select "+ className}
      >
        {
          title
            ? <option value="" disabled>{title}</option>
            : null
        }
        {options.map((option, idx) => (
          <option
            key={idx}
            value={optionValues.length === options.length ? optionValues[idx] : option}
            disabled={disabledOptions ? disabledOptions[idx] : false}
          >
            {option}
          </option>
        ))}
      </select>
    );
  }
}

Dropdown.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  optionValues: PropTypes.array,
  disabledOptions: PropTypes.array,
  customOnChange: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Dropdown.defaultProps = {
  name: '',
  title: '',
  optionValues: [],
  disabledOptions: null,
  customOnChange: true,
  className: '',
};
